<template>
	<main id="archive-posts" class="archive page main margin-both-lg" :key="'archive-'+currentPostType">
		<div v-if="currentPostType !== 'teachers'" class="headg-filters margin-bottom-lg">
			<HomeFilterLinks :title="false" :search="!(currentPostType !== 'educations' && currentPostType !== 'professions')" class="on-archive" @onChange="filtersUpdate" />
		</div>
		<PostsGrid :posts="postsToShow.slice(0, toShowCount)" class="container container--large" />
		<div v-if="isMoreToShow && postsToShow.length"  class="margin-both load-more-button text-center">
			<Button aria-label="Load more elements" hasIcon iconType="down" uppercase v-observe-visibility="visibilityChanged" type="darkLight" @click.native="loadMore()">LOAD MORE</Button>
		</div>
		<div v-if="postsLoaded && !isMoreToShow && postsToShow.length == 0"  class="container no-resultats margin-bottom-lg text-center">
			<div class="inner-error">{{_('try different filters')}}</div>
		</div>
	</main>
</template>


<script>
import SingleHeading from '@/components/SingleHeading'
import PostsGrid from '@/components/parts/PostsGrid'
import Button from '@/components/elements/Button'
import HomeFilterLinks from '@/components/elements/HomeFIlterLinks'

import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'archive-page',
	components:{
		SingleHeading,
		PostsGrid,
		Button,
		HomeFilterLinks
	},
	data(){
        return{
			selectedCategory: '',
			postsLoaded: false,
			multiFilters: {
				education_level : [],
				work_place : [],
				category_ambasador : {},
				category : {},
				interests : []
			},
			searchQuery: '',
			posts: [],
			toShowDefault: 6,
			toShowCount: 6,
			showBy: 6,
			countAll: 0,
		}
	},
	watch:{
		postsLoaded(val){
			if(val){
				const urlFilters = Object.assign({}, this.$route.query);
				let query = {}
				if(Object.keys(urlFilters).length ){
					if(urlFilters.hasOwnProperty('category_ambasador')){
						query = {...query, ... urlFilters }
					}
					if(urlFilters.hasOwnProperty('category')){
						query = {...query, ... urlFilters }
					}
					//consoleconsole.log(query)
				}
				//trigger first router/filters action
			}
		},

	},
	mounted(){
		this.loadPosts();
		//console.log(this.$route)
	},
	methods:{
		filtersUpdate(value){
			switch (value.action) {
				case 'search':
					this.searchQuery = value.value;
					break;
				case 'category_ambasador':
				case 'category':
				case 'education_level':
				case 'work_place':
				case 'interests':
					this.multiFilters[value.action] = value.value;
					break;
			}
		},
		...mapActions([
			'getPost',
		]),
		loadPosts(){
			const VM = this;
			VM.getPost(VM.apiOptLoad).then(res => {
				const { posts } = res.data;
				if(posts && posts.length){
					VM.countAll = posts.length;
					VM.posts = posts;
					VM.postsLoaded = true;
				}
			})
		},
		loadMore(){
			this.toShowCount = this.toShowCount + this.showBy
		},
		visibilityChanged(isVisible){
			if(isVisible){
				this.loadMore();
			}
		},
	},
	computed: {
		...mapGetters([
			'storedTaxonomy',
			'currentPostType',
			'storedTaxonomyBySlug'
		]),
		apiOptLoad(){
			return {
				type: this.currentPostType || 'post',
				order_by : 'menu_order',
				order : 'ASC',
				limit: 50000,
			}
		},
		
		isMoreToShow(){
			return this.toShowCount < this.postsToShow.length
		},
		postsToShow(){
			const VM = this;
			if(!this.posts) return false
			const toShow = VM.posts.filter((p,i)=>{
				let showMe = true;
				let useFilters = false;


				//filter for Posts #category
				if(VM.multiFilters.category && VM.multiFilters.category.slug){
					useFilters = true;
					const category = VM.storedTaxonomyBySlug('category', VM.multiFilters.category.slug);
					const postCategory = p.acf && p.acf.category && p.acf.category;
					showMe = (category && postCategory && ~postCategory.indexOf(category.id)) ? true : false
				}

				//filter for Ambasadors #category_ambasador
				if(VM.multiFilters.category_ambasador && VM.multiFilters.category_ambasador.slug){
					useFilters = true;
					const category = VM.storedTaxonomyBySlug('category_ambasador', VM.multiFilters.category_ambasador.slug);
					const postCategory = p.acf && p.acf.category && p.acf.category;
					showMe = (category && postCategory && ~postCategory.indexOf(category.id)) ? true : false
				}

				if(VM.multiFilters.education_level && VM.multiFilters.education_level.length && showMe){
					useFilters = true;
					if(p.acf && p.acf.education_level){
						if(VM.multiFilters.education_level.some(r=> p.acf.education_level.indexOf(r.id) >= 0)){
							showMe = true
						}else{
							showMe = false
						}
					}
				}
				
				if(VM.multiFilters.work_place && VM.multiFilters.work_place.length && showMe){
					useFilters = true;
					if(p.acf && p.acf.work_place){
						if(VM.multiFilters.work_place.some(r=> p.acf.work_place.indexOf(r.id) >= 0)){
							showMe = true
						}else{
							showMe = false
						}
					}
				}

				if(VM.multiFilters.interests && VM.multiFilters.interests.length && showMe){
					useFilters = true;
					if(p.acf && p.acf.interests){
						if(VM.multiFilters.interests.some(r=> p.acf.interests.indexOf(r.id) >= 0)){
							showMe = true
						}else{
							showMe = false
						}
					}
				}

				if(VM.searchQuery && showMe){
					useFilters = true;
					showMe = (p.title.toUpperCase().indexOf(VM.searchQuery.toUpperCase()) > -1)
				}
				
				
				//return all if no filters were used
				return useFilters ? showMe : true
			})

			return (toShow && toShow.length) ?  toShow : []
		}
	},

}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.load-more-button .fill-button-text{
	font-size: 18px;
}
.archive{
	.no-resultats{
		max-width: 740px;
		margin-top:-25px;
		.inner-error{
			border-radius: $blocksRadius;
			padding: 15px 25px;
			background-color: #fff;
		}
	}
	.professions-filters{
		margin-left: auto;
		margin-right: auto;
		max-width: 950px;
		background-color: transparent;
		&:after, &:before{
			content: none;
		}
	}
	.archive-filters-single{
		max-width: 350px;
		margin: 0 auto;
		&.is-multiple{
			.vs__selected{
				background: $light;
				border: none;
				padding: 3px 5px;
            	@include fluid-type($smallResText, $wideResText, 12px, 14px);
				color: $dark;
				border-radius: 40px;
			}
			.vs__selected-options{
				svg path{
					fill: $dark;
				}
			}
		}
		.vs__selected-options{
			flex-wrap: nowrap;
			align-items: center;
		}
		.vs__actions{
			padding-right:25px;
		}
		.vs__selected{
			color: #fff;
			padding-left:25px;
			margin: 0;
		}
		.vs__clear{
			path{
				fill: #fff;
			}
		}
		.vs__dropdown-toggle{
			border: none;
			background-color: $darkLight;
			border-radius: 30px;
			color: #fff;
			cursor: pointer;
			white-space: nowrap;
			input{
				padding: 10px 24px;
				padding-right: 2px;
				margin-top: 0;
				color: #fff;
			}
		}
		.vs__open-indicator{
			fill: #fff;
		}
	}
}
</style>